import { languageMap } from ".."

languageMap.batch = {
	comments: {
		line: "::",
	},
}
